'use client';

interface FullShareViewFootnoteProps {
  text: string;
  ctaLabel: string;
  ownerUrl?: string;
}

export function FullShareViewFootnote({
  text,
  ctaLabel,
  ownerUrl,
}: FullShareViewFootnoteProps) {
  return (
    <div
      data-hook="share-footnote"
      className="shrink-0 bg-[#f8f6f6] px-6 py-4 text-xs leading-3 text-[#151414]"
    >
      {text}{' '}
      {ownerUrl ? (
        <button
          type="button"
          data-hook="share-footnote-cta"
          onClick={() => window.open(ownerUrl, '_blank')}
          className="cursor-pointer text-[#2f5dff] underline hover:opacity-80"
        >
          {ctaLabel}
        </button>
      ) : (
        ctaLabel
      )}
    </div>
  );
}
